
import React, { useEffect, useRef, useState } from 'react';
import { IoIosClose, IoIosAdd, IoIosCheckmark, IoMdCreate } from "react-icons/io";
import { Api } from '../../../../services/api';
import { InputTextarea } from 'primereact/inputtextarea';

const CoreValues = () => {


    const [showFields, setShowFields] = useState(false);
    const [isAdmin, setIsAdmin] = useState(false);
    const [formData, setFormData] = useState({
        core: [{ value: '', description: '' }],
    });


    useEffect(() => {
        fetchData();
        const adminStatus = localStorage.getItem('isAdmin');
        setIsAdmin(adminStatus === 'Y');
    }, []);


    const fetchData = async () => {
        try {
            const token = localStorage.getItem('authToken');
            const response = await fetch(Api.API_BASE_URL + 'business-core/vision/core-value/get', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token ? `Bearer ${token}` : ''
                },

            });
            const data = await response.json();
            // setFormData({ core: data });
            if (Array.isArray(data.result)) {
                const mappedData = data.result.map(item => ({
                    value: item.core_value || '',
                    description: item.description || ''
                }));
                setFormData({ core: mappedData.length > 0 ? mappedData : [{ value: '', description: '' }] });
            } else {
                setFormData({ core: [{ value: '', description: '' }] });
            }
        } catch (error) {
            console.error('Error fetching data:', error);
            setFormData({ core: [] });
        }
    };

    const handleFieldChange = (e, field, index) => {
        const newCore = [...formData.core];
        newCore[index][field] = e.target.value;
        setFormData({
            ...formData,
            core: newCore,
        });
    };


    const handleAddField = (index) => {
        setFormData({
            ...formData,
            core: [
                { description: '', value: '' }, ...formData.core,

            ],
        });

    }

    const handleDelete = (index) => {
        const newCore = [...formData.core];
        newCore.splice(index, 1);
        setFormData({
            ...formData,
            core: newCore,
        });
    };




    const handleEdit = () => {
        // setShowFields(true);
        setShowFields(!showFields);

    };

    const handleSave = async () => {
        setShowFields(false);
        try {
            const token = localStorage.getItem('authToken');

            const payload = {
                core_value: formData.core
            };

            const response = await fetch(Api.API_BASE_URL + 'business-core/vision/core-value/save', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token ? `Bearer ${token}` : ''
                },
                body: JSON.stringify(payload),
            });

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            const result = await response.json();
            console.log('Data saved successfully:', result);
        } catch (error) {
            console.error('Error saving data:', error);
        }
    };

// TODO---------------------------
const textareaStyle = {
    width: '100%',
    height: "40px",
    boxSizing: 'border-box',
    outline: 'none',
    fontSize: '16px',
    color: '#495057',
    display: 'flex',
    alignItems: 'center',
    padding: '8px',
    // border: 'none',
    // borderBottom: '1px solid #ccc',
    border: '1px solid #ccc',
};
// TODO---------------------------


    return (
        <div className="row ">

            <div className="col-12 box3 mb-4">
                <div className="box-header">
                    <h4 className='title-font'>Core Values</h4>
                  
                    {isAdmin && (
                        showFields ? (
                            <IoIosCheckmark
                                onClick={handleSave}
                                style={{
                                    fontSize: '40px',
                                    cursor: 'pointer',
                                }}
                            />
                        ) : (
                            <IoMdCreate
                                onClick={handleEdit}
                                style={{
                                    fontSize: '20px',
                                    cursor: 'pointer',
                                }}
                            />
                        )
                    )}

                </div>
                <div className="box-body" >
                    {showFields ? (
                        <>
                            {formData.core.map((field, index) => (
                                <div
                                    key={index}
                                    style={{
                                        display: 'flex',
                                        gap: '10px',
                                        marginTop: '10px',
                                        fontSize: '14px'
                                    }}
                                >
                                    {/* Title Input Field */}
                                    <div style={{ flex: 1 }}>
                                        <label htmlFor={`title-${index}`} style={{ display: 'block', marginBottom: '5px', fontSize: '14px', fontWeight:'400' }}>
                                            Core Value*
                                        </label>
                                        
                                        <InputTextarea
                                            id={`title-${index}`}
                                            type="text"
                                            autoResize
                                            value={field.value}
                                            onChange={(e) => handleFieldChange(e, 'value', index)}
                                            rows={2}
                                            className='s'
                                            style={textareaStyle}
                                        />
                                    </div>

                                    {/* Description Textarea Field */}
                                    <div style={{ flex: 2 }}>
                                        <label htmlFor={`description-${index}`} style={{ display: 'block', marginBottom: '5px', fontSize: '14px', fontWeight:'400' }}>
                                            Description*
                                        </label>
                                      
                                        <InputTextarea
                                            autoResize
                                            id={`description-${index}`}
                                            value={field.description}
                                            onChange={(e) => handleFieldChange(e, 'description', index)}
                                            style={textareaStyle}
                                        ></InputTextarea>
                                    </div>

                                    {/* Add/Save and Delete Icons */}
                                    {index > 0 ? (
                                        <IoIosClose
                                            onClick={() => handleDelete(index)}
                                            style={{
                                                fontSize: '40px',
                                                cursor: 'pointer',
                                                color: 'red',
                                            }}
                                        />
                                    ) : (
                                        <>
                                            <IoIosAdd
                                                onClick={handleAddField}
                                                style={{
                                                    fontSize: '40px',
                                                    cursor: 'pointer',
                                                }}
                                            />
                                           
                                        </>
                                    )}
                                </div>
                            ))}
                        </>
                    ) : (
                        formData.core.map((field, index) => (
                            <div className='row'
                                key={index}
                                style={{
                                    padding: '2px 2px',
                                    // marginTop: '5px',
                                    borderRadius: '5px',
                                    display: 'flex',
                                }}
                            >
                                <div className='col-4'>
                                    <p>
                                        {field.value}
                                    </p>
                                </div>
                                <div className='col-8'>
                                    <p>
                                        {field.description}
                                    </p>
                                </div>
                                {showFields && (
                                    <IoIosClose
                                        onClick={() => handleDelete(index)}
                                        style={{
                                            fontSize: '20px',
                                            cursor: 'pointer',
                                            color: 'red',
                                        }}
                                    />
                                )}
                            </div>
                        ))
                    )}
                </div>
            </div>
        </div>
    )
}

export default CoreValues